"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPSERT_CONCEPT_CHAPTER_FRAGMENT = exports.UPSERT_CONCEPT_NOTE_FRAGMENT = exports.STATUS_CONCEPT_FRAGMENT = exports.CONCEPT_FIELDS = void 0;
const client_1 = require("@apollo/client");
const chapter_1 = require("./chapter");
const video_1 = require("./video");
exports.CONCEPT_FIELDS = (0, client_1.gql) `
  ${chapter_1.CHAPTER_FIELDS}
  ${video_1.VIDEO_FIELDS}
  fragment ConceptFields on Concept {
    id
    name
    demo
    status
    typeId
    entitlement {
      id
      name
    }
    topicId
    topic {
      id
      name
      typeId
    }
    chapterId
    chapter {
      ...ChapterFields
    }
    videos {
      ...VideoFields
    }
    userNote {
      id
      userId
      conceptId
      note
      updatedAt
    }
    userChapter {
      id
      userId
      conceptId
      explanation
      updatedAt
    }
  }
`;
// used in cache updator
exports.STATUS_CONCEPT_FRAGMENT = (0, client_1.gql) `
  fragment ConceptStatus on Concept {
    status
  }
`;
// used in cache updator
exports.UPSERT_CONCEPT_NOTE_FRAGMENT = (0, client_1.gql) `
  fragment UpsertConceptNoteFragment on Concept {
    userNote {
      userId
      note
      conceptId
      createdAt
      updatedAt
    }
  }
`;
// used in cache updator
exports.UPSERT_CONCEPT_CHAPTER_FRAGMENT = (0, client_1.gql) `
  fragment UpsertConceptChapterFragment on Concept {
    userChapter {
      userId
      explanation
      conceptId
      createdAt
      updatedAt
    }
  }
`;
